// extracted by mini-css-extract-plugin
export default {"SidebarItemWrapper":"ItemMigration_SidebarItemWrapper__h0gdG","active":"ItemMigration_active__MQTwQ"};